<template>
  <div class="content">
    <div class="header d-flex justify-content-between align-items-center mb-4">
      <div class="title d-flex align-center">
        <v-btn icon color="primary" class="mr-3" @click="goBack" title="Voltar ao Painel FORMP&D">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div>
          <h3 class="h3 mb-n2 font-weight-bold">Avaliação MCTI (Pareceres)</h3>
          <span class="subtitle-2 grey--text text--darken-1" v-if="prestacaoId && String(prestacaoId) !== '0'">Detalhamento de pareceres do documento</span>
          <span class="subtitle-2 grey--text text--darken-1" v-else>Visão consolidada de pareceres</span>
        </div>
      </div>
      <div class="actions d-flex flex-row align-center">
        <v-btn class="elevation-4 mr-2" @click="refreshAll" outlined>
          <v-icon left dark>mdi-refresh</v-icon>
          <span style="font-size: 12px">Atualizar</span>
        </v-btn>
      </div>
    </div>

    <v-row align="center" class="mt-2 mb-4 mx-0">
      <v-spacer />
      <v-col cols="auto" class="d-flex align-center">
        <v-btn 
          v-if="canAdd && prestacaoId && String(prestacaoId) !== '0'"
          class="elevation-4" 
          color="primary" 
          style="background-color: #1ccb5b;" 
          @click="openAddModal"
        >
          <v-icon left>mdi-plus</v-icon>
          <span style="font-size: 12px">Adicionar</span>
        </v-btn>
      </v-col>
    </v-row>

    <div class="body">
      <div v-for="type in filteredTypes" :key="type.id" class="mb-6">
        <div class="d-flex justify-content-between align-items-center m-3">
          <span class="h5 mb-0 font-weight-bold">{{ type.name }}</span>
        </div>
        
        <div class="teros-elevation rounded">
          <v-data-table
            class="mb-6 fixed-table"
            :headers="computedHeaders"
            :items="items[type.id]"
            :options.sync="options[type.id]"
            :loading="loading[type.id]"
            :footer-props="{
              'items-per-page-options': [10, 15, 30, 50, -1],
              'items-per-page-text': 'Itens por página'
            }"
          >
            <template v-slot:item.dispendios_aprovados="{ item }">
              <v-chip outlined small color="primary" v-if="item.dispendios_aprovados">{{ item.dispendios_aprovados }}</v-chip>
            </template>
            <template v-slot:item.incremento_pesquisador="{ item }">
              <v-chip outlined small color="secondary" v-if="item.incremento_pesquisador">{{ item.incremento_pesquisador }}</v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip small :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
            </template>
            <template v-slot:item.total_dispendios_contestados="{ item }">
              {{ item.total_dispendios_contestados ? formatCurrency(item.total_dispendios_contestados) : '-' }}
            </template>
            <template v-slot:item.total_dispendios_reportados="{ item }">
              {{ item.total_dispendios_reportados ? formatCurrency(item.total_dispendios_reportados) : '-' }}
            </template>
            <template v-slot:item.data_publicacao_lote="{ item }">
              {{ item.data_publicacao_lote ? formatDateBR(item.data_publicacao_lote) : '-' }}
            </template>

            <template v-slot:item.acoes="{ item }" v-if="prestacaoId && String(prestacaoId) !== '0'">
              <v-btn v-if="canEdit" icon small color="primary" @click="editParecer(item, type.id)" title="Editar">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn v-if="canDelete" icon small color="error" @click="confirmDelete(item)" title="Remover">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>

    <!-- Modal FormModal -->
    <FormModal
      :max-width="900"
      :title="isEditing ? 'Editar Parecer MCTI' : 'Adicionar Parecer MCTI'"
      :opened.sync="isVisibleFormModal"
      :value.sync="formModalData"
      :errorMessage="errorMessage"
      :cols="colsFormFiltered"
      :opts="opts"
      cancel-button-color="white"
      @save="doSave"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { toCurrency, toCurrencySave } from "@/helpers/toCurrency";
import { userHasAccess } from "@/helpers/permissionValidator";
import { UserTypeEnum } from "@/core/enums/user-types";

export default {
  name: "PareceresMctiListing",
  components: {
    FormModal: () => import("@/components/form-modal.vue")
  },
  data() {
    return {
      prestacaoId: this.$route.params.prestacaoId,
      selectedInstancia: this.$route.query.instancia ? parseInt(this.$route.query.instancia) : null,
      anoBase: this.$route.query.anoBase || null,
      isEditing: false,
      editId: null,
      types: [
        { id: 1, name: "Parecer Técnico" },
        { id: 2, name: "Parecer Técnico Contestação" },
        { id: 3, name: "Parecer Técnico Recurso Administrativo" }
      ],
      isVisibleFormModal: false,
      items: { 1: [], 2: [], 3: [] },
      totalItems: { 1: 0, 2: 0, 3: 0 },
      loading: { 1: false, 2: false, 3: false },
      options: { 
        1: { page: 1, itemsPerPage: 15 }, 
        2: { page: 1, itemsPerPage: 15 }, 
        3: { page: 1, itemsPerPage: 15 } 
      },
      formModalData: {},
      errorMessage: "",
      opts: {
        instancias: [
          { value: 1, text: "Parecer Técnico" },
          { value: 2, text: "Parecer Técnico Contestação" },
          { value: 3, text: "Parecer Técnico Recurso Administrativo" }
        ],
        // Todos os status valem para as tres instancias. "Nao recomendado" ja foi restrito ao
        // Recurso Administrativo, mas os pareceres reais do MCTI trazem reprovacao total tambem
        // no Parecer Tecnico e na Contestacao (a importacao do Painel FORMP&D grava esses casos),
        // e a restricao limpava o campo ao editar o registro na tela.
        statusList: [
          { value: "Recomendado", text: "Recomendado" },
          { value: "Parcialmente recomendado", text: "Parcialmente recomendado" },
          { value: "Não recomendado", text: "Não recomendado" },
          { value: "Enviado", text: "Enviado" },
          { value: "Em elaboração", text: "Em elaboração" }
        ],
        dispendiosAprovadosList: [
          { value: "Integral", text: "Integral" },
          { value: "Parcial", text: "Parcial" },
          { value: "Não Aprovados", text: "Não Aprovados" }
        ],
        incrementoList: [
          { value: "Aprovado", text: "Aprovado" },
          { value: "Não Aprovado", text: "Não Aprovado" },
          { value: "Não se Aplica", text: "Não se Aplica" }
        ],
        itensNaoRecomendadosList: [
          { value: "Elemento Tecnologicamente Novo ou Inovador", text: "Elemento Tecnologicamente Novo ou Inovador" },
          { value: "Barreira ou Desafio Tecnológico", text: "Barreira ou Desafio Tecnológico" },
          { value: "Metodologia/Métodos", text: "Metodologia/Métodos" },
          { value: "Recursos Humanos", text: "Recursos Humanos" },
          { value: "Serviços de Terceiros", text: "Serviços de Terceiros" },
          { value: "Materiais de Consumo", text: "Materiais de Consumo" },
          { value: "Incremento de Pesquisadores", text: "Incremento de Pesquisadores" }
        ]
      },
      cols: [
        { value: "status", text: "Status", align: "start", width: "210px" },
        { value: "numero_lote", text: "Nº do Lote", align: "start", width: "120px" },
        { value: "data_publicacao_lote", text: "Data Pub. Lote", align: "start", width: "150px" },
        { value: "projetos_defendidos", text: "Proj. Defend.", align: "start", width: "135px" },
        { value: "projetos_aprovados", text: "Proj. Aprov.", align: "start", width: "130px" },
        { value: "dispendios_aprovados", text: "Dispêndios Aprov.", align: "start", width: "170px" },
        { value: "total_dispendios_contestados", text: "Disp. Contestados", align: "start", width: "170px" },
        { value: "total_dispendios_reportados", text: "Disp. Reportados", align: "start", width: "170px" },
        { value: "incremento_pesquisador", text: "Incr. Pesq. Aprov.", align: "start", width: "165px" },
        { value: "acoes", text: "Ações", align: "start", sortable: false, width: "100px" }
      ],
      colsForm: [
        {
          key: "instancia",
          name: "Selecionar Linha (Parecer)",
          type: this.$fieldTypes.SELECT,
          rel: { to: "instancias", key: "value", name: "text" },
          rules: [{ rule: "required" }],
          colSize: 12
        },
        {
          key: "status",
          name: "Status",
          type: this.$fieldTypes.SELECT,
          rel: { to: "statusList", key: "value", name: "text" },
          rules: [{ rule: "required" }],
          colSize: 4
        },
        {
          key: "numero_lote",
          name: "Número do Lote",
          type: this.$fieldTypes.NUMBER,
          colSize: 4,
        },
        {
          key: "data_publicacao_lote",
          name: "Data Pub. Lote",
          type: this.$fieldTypes.DATE,
          maxDate: moment().endOf('year').format('YYYY-MM-DD'),
          colSize: 4
        },
        {
          key: "projetos_defendidos",
          name: "Nº Proj. Defendidos",
          type: this.$fieldTypes.NUMBER,
          colSize: 3
        },
        {
          key: "projetos_aprovados",
          name: "Nº Proj. Aprovados",
          type: this.$fieldTypes.NUMBER,
          colSize: 3
        },
        {
          key: "dispendios_aprovados",
          name: "Dispêndios Aprovados",
          type: this.$fieldTypes.SELECT,
          rel: { to: "dispendiosAprovadosList", key: "value", name: "text" },
          colSize: 6
        },
        {
          key: "total_dispendios_reportados",
          name: "Total de Disp. Reportados",
          type: this.$fieldTypes.MONEY,
          colSize: 6
        },
        {
          key: "total_dispendios_contestados",
          name: "Total de Disp. Contestados",
          type: this.$fieldTypes.MONEY,
          colSize: 6
        },
        {
          key: "incremento_pesquisador",
          name: "Incremento Pesquisador aprovado",
          type: this.$fieldTypes.SELECT,
          rel: { to: "incrementoList", key: "value", name: "text" },
          colSize: 6
        },
        {
          key: "itens_nao_recomendados",
          name: "Itens não recomendados",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "itensNaoRecomendadosList", key: "value", name: "text" },
          colSize: 6
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["clientId", "user"]),
    canAdd() {
      if (this.user?.tipo_usuario !== UserTypeEnum.COLABORADOR) return true;
      return userHasAccess(this.user, 'Cadastro.prestacaoContasPareceres.create');
    },
    canEdit() {
      if (this.user?.tipo_usuario !== UserTypeEnum.COLABORADOR) return true;
      return userHasAccess(this.user, 'Cadastro.prestacaoContasPareceres.update');
    },
    canDelete() {
      if (this.user?.tipo_usuario !== UserTypeEnum.COLABORADOR) return true;
      return userHasAccess(this.user, 'Cadastro.prestacaoContasPareceres.delete');
    },
    computedHeaders() {
      let filteredCols = this.cols;
      if ((!this.canEdit && !this.canDelete) || (this.prestacaoId && String(this.prestacaoId) === '0')) {
        filteredCols = filteredCols.filter(c => c.value !== 'acoes');
      }
      return filteredCols.map(h => ({
        ...h,
        class: `vuetify-table-header${
          this.getClient && this.getClient().isClient ? "-cli" : ""
        }`
      }));
    },
    colsFormFiltered() {
      return this.colsForm.map(c => {
         const shouldBlockInstancia = c.key === 'instancia' && (this.isEditing || !!this.selectedInstancia);
         return {
           ...c,
           disabled: shouldBlockInstancia ? true : !!c.disabled,
           editable: shouldBlockInstancia ? false : (c.editable !== undefined ? c.editable : true)
         };
      });
    },
    filteredTypes() {
      if (this.selectedInstancia) {
        return this.types.filter(t => t.id === this.selectedInstancia);
      }
      return this.types;
    }
  },
  watch: {
    clientId() {
      this.refreshAll();
    }
  },
  mounted() {
    this.refreshAll();
  },
  methods: {
    goBack() {
      this.$router.push({ 
        name: 'listagem-prestacao-contas',
        query: { anoBase: this.anoBase }
      });
    },
    formatCurrency(value) {
      if (!value) return null;
      return toCurrency(value);
    },
    formatDateBR(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY");
    },
    getStatusColor(status) {
      switch(status) {
        case 'Recomendado': return 'success';
        case 'Não recomendado': return 'error';
        case 'Parcialmente recomendado': return 'warning';
        case 'Enviado': return 'info';
        case 'Em elaboração': return 'secondary';
        default: return 'grey';
      }
    },
    refreshAll() {
      this.fetchData();
    },
    fetchData() {
      this.types.forEach(type => {
        this.loading[type.id] = true;
      });
      
      const resource = this.apiResource(`v1/cadastro/${this.clientId}/pareceres-mcti`);
      
      const queryParams = {
        per_page: 999,
        'filters[ano_base]': this.anoBase
      };
      
      if (this.prestacaoId && String(this.prestacaoId) !== '0') {
         queryParams['filters[prestacao_contas_id]'] = this.prestacaoId;
      }
      
      const qs = new URLSearchParams(queryParams).toString();
      
      resource.get({ query: qs }).then(res => {
        const d = res.data || [];
        this.items[1] = [];
        this.items[2] = [];
        this.items[3] = [];

        d.forEach(item => {
            if (item.instancia && this.items[item.instancia]) {
                this.items[item.instancia].push(item);
            }
        });
      }).catch(() => {
        
      }).finally(() => {
        this.types.forEach(type => {
          this.loading[type.id] = false;
        });
      });
    },
    openAddModal() {
      this.isEditing = false;
      this.editId = null;
      this.formModalData = {
        instancia: this.selectedInstancia || null,
      };
      this.errorMessage = "";
      this.isVisibleFormModal = true;
    },
    editParecer(item, typeId) {
      this.isEditing = true;
      this.editId = item.id;
      this.formModalData = {
          ...item,
          instancia: typeId,
          total_dispendios_reportados: item.total_dispendios_reportados,
          total_dispendios_contestados: item.total_dispendios_contestados,
          data_publicacao_lote: item.data_publicacao_lote ? moment(item.data_publicacao_lote).format("YYYY-MM-DD") : null
      };
      this.errorMessage = "";
      this.isVisibleFormModal = true;
    },
    doSave(data) {
      const resource = this.apiResource(`v1/cadastro/${this.clientId}/pareceres-mcti`);
      
      let payload = {
          ...data,
          prestacao_contas_id: this.prestacaoId,
          total_dispendios_reportados: data.total_dispendios_reportados ? toCurrencySave(data.total_dispendios_reportados) : null,
          total_dispendios_contestados: data.total_dispendios_contestados ? toCurrencySave(data.total_dispendios_contestados) : null
      };

      let action = this.isEditing ? resource.save(payload, this.editId) : resource.save(payload);




      action.then(() => {
        this.$notify({
          group: "geral",
          type: "success",
          title: "Sucesso",
          text: "Parecer salvo com sucesso!"
        });
        
        this.isVisibleFormModal = false;
        this.fetchData();
      }).catch(err => {
        this.errorMessage = err.response?.data?.error
          || Object.values(err.response?.data?.errors || {}).flat()[0]
          || err.response?.data?.message
          || "Erro ao salvar Parecer.";
      });
    },
    confirmDelete(row) {
      this.showConfirm(
        "Confirmação",
        "Deseja realmente remover este parecer?",
        () => {
          const resource = this.apiResource(`v1/cadastro/${this.clientId}/pareceres-mcti`);
          resource.delete(row.id).then(() => {
            this.$notify({
              group: "geral",
              type: "success",
              title: "Removido",
              text: "Parecer removido com sucesso!"
            });
            this.fetchData();
          });
        }
      );
    }
  }
};
</script>

<style scoped>
.content {
  padding: 1.5rem;
}
.header {
  padding-bottom: 15px;
}
</style>

<style>
/* Força alinhamento fixo de colunas em todas as tabelas de pareceres */
.fixed-table table {
  table-layout: fixed;
  width: 100%;
}
.fixed-table th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
